import React from "react";
import { ReactComponent as LogoSVG } from "../../assets/images/logo.svg";
import { Link } from "react-router-dom";

const Logo = ({classes="max-w-md py-0 lg:py-5 absolute top-5 z-10 left-1/2 -translate-x-1/2 sm:left-10 sm:translate-x-0 md:z-0"}) => {
  return (
    <>
      <div className={classes}>
        <Link to="/">
          <LogoSVG />
        </Link>
      </div>
    </>
  );
};

export default Logo;
